import "./home-landing.component.scss";

export default {
  template: require('./home-landing.component.html'),
  controller: function ($timeout, $element, $routeParams, $location, ToggleLD, AuthService, UsersPublicApi) {
    'ngInject';

    const hideLoadIndicator = () => {
      ToggleLD.hide();
    };

    if ($routeParams.activationToken) {
      ToggleLD.show();
      AuthService.activation($routeParams.activationToken, () => {
        AuthService.currentUser(user => {
          if (user.role === 'USER') {
            $location.path('/bicycle-owner/service-bookings');
          } else {
            $location.path('/dashboard');
          }

          hideLoadIndicator();
        }, true);
      }, hideLoadIndicator);
    }
    if ($routeParams.cancelToken) {
      AuthService.cancelActivation(UsersPublicApi.cancelRegistration, $routeParams.cancelToken, hideLoadIndicator, hideLoadIndicator);
    }
  }
};
